import { computed } from 'mobx';
import { ROLE } from '@link/share/constants';
import { BaseAuth } from '@link/share/stores';

export class Auth extends BaseAuth {
  @computed
  get email(): string {
    return this.user?.email || '';
  }

  @computed
  get isAdmin(): boolean {
    return this.claims?.OTA_SERVICE?.role === ROLE.ADMIN;
  }
  @computed
  get isOperator(): boolean {
    return this.claims?.OTA_SERVICE?.role === ROLE.OPERATOR;
  }
  @computed
  get isViewer(): boolean {
    return this.claims?.OTA_SERVICE?.role === ROLE.VIEWER;
  }
  @computed
  get canOperate(): boolean {
    return this.isAdmin || this.isLinkAdmin || this.isOperator;
  }
  @computed
  get isUnauthorizedUser(): boolean {
    return !this.claims?.OTA_SERVICE;
  }
  @computed
  get userAgentId(): string {
    return this.claims?.OTA_SERVICE?.['ota-id'] || '';
  }
  @computed
  get userOtaOrgId(): string {
    return this.claims?.OTA_SERVICE?.['group-id'] || '';
  }
}

export default new Auth();
